/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type PatientAuthorizationClaimUsageStatus = typeof PatientAuthorizationClaimUsageStatus[keyof typeof PatientAuthorizationClaimUsageStatus];


export const PatientAuthorizationClaimUsageStatus = {
  Counted: 'Counted',
  NotCounted: 'NotCounted',
} as const;
